import React, { useEffect, useState } from 'react';
import fetchFixedBudgetVessels from './queries/fetchFixedBudgetVessels';
import getTotalNoOfPages from '../../utils/getTotalNoOfPages';
import ApiPagination from '../common/ApiPagination';
import { renderLabel } from '../../utils/formatDropdownOptions';

const paginationRowList = [10, 20, 30, 40, 50];

const getRowId = (item) => (
  item?.fixedBudgetVesselId
  || item?.fixedBudgetVesselCompanyCodeId
  || item?.vesselCostCenterId
  || item?.id
);

// const formatNameWithCode = (name, code) => {
//   const displayName = (name && String(name).trim()) || '';
//   const displayCode = (code != null && String(code).trim() !== '') ? String(code).trim() : '';
//   if (displayName && displayCode) {
//     return `${displayName} (${displayCode})`;
//   }
//   return displayName || displayCode || '-';
// };

const formatVesselDisplay = (item) => {
  const vesselName = String(item?.vesselName || '').trim();
  const vesselCode = String(item?.vesselCode || item?.plannedVesselCode || '').trim();
  const sapVesselCompanyCode = String(
    item?.sapVesselCompanyCode
    || item?.sapVesselCompanyCode
    || item?.vesselCompanyCode
    || ''
  ).trim();

  if (!vesselName && !vesselCode && !sapVesselCompanyCode) {
    return '-';
  }

  let label = vesselName;
  if (vesselCode) {
    label = label ? `${label} (${vesselCode})` : `(${vesselCode})`;
  }
  if (sapVesselCompanyCode) {
    label = label ? `${label} (${sapVesselCompanyCode})` : `(${sapVesselCompanyCode})`;
  }
  return label || '-';
};

const getCostCenterDisplay = (item) => (
  item?.fixedCostCenter
  || item?.fixedCostCentre
  || '-'
);

const FixedBudgetVesselTable = ({
  policies,
  canManage,
  selectedIds,
  setSelectedIds,
  search,
  pageNumber,
  setpageNumber,
  rowsCount,
  setrowsCount
}) => {
  const [totalPages, settotalPages] = useState(0);

  useEffect(() => {
    if (search?.length > 2) {
      setpageNumber(1);
    }
  }, [search]);

  const reqObj = {
    pageNumber,
    rowsCount,
    search: search?.length > 2 ? search : null
  };

  const {
    isLoading,
    error,
    isFetching,
    data,
    isError
  } = fetchFixedBudgetVessels(reqObj);

  const listData = data?.data || {};
  const records = listData?.fixedBudgetVesselModels
    || listData?.fixedBudgetVesselList
    || listData?.items
    || listData?.data
    || [];
  const totalRowsCount = listData?.totalRowsCount || listData?.totalCount || 0;

  useEffect(() => {
    settotalPages(getTotalNoOfPages(totalRowsCount, rowsCount));
  }, [pageNumber, totalRowsCount, rowsCount]);

  useEffect(() => {
    setSelectedIds([]);
  }, [pageNumber, rowsCount, search, records?.length]);

  if (isError) {
    return <>{error?.message || 'Something went wrong'}</>;
  }

  const handleRowsCount = (value) => {
    setpageNumber(1);
    setrowsCount(value);
  };

  const pageIds = (records || []).map(getRowId).filter(Boolean);
  const allSelected = pageIds.length > 0 && pageIds.every((id) => selectedIds.includes(id));

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedIds((prev) => prev.filter((id) => !pageIds.includes(id)));
    } else {
      setSelectedIds((prev) => Array.from(new Set([...prev, ...pageIds])));
    }
  };

  const toggleSelectRow = (id) => {
    if (!id) return;
    setSelectedIds((prev) => (
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    ));
  };

  const canEdit = canManage === true
    || policies?.sapPoAdminPolicies?.canEdit === true
    || policies?.sapPoAdminPolicies?.canAccess === true;

  const vesselStatus = (item) => item?.vesselStatus || item?.status;

  return (
    <>
      <div className={`manning-table muli expense-item fixed-budget-vessel-company-code ${canEdit ? 'with-select' : ''}`}>
        <div className="table-row table-head bg-primary-50">
          {canEdit && (
            <div className="table-cell">
              <input
                type="checkbox"
                className="cost-select"
                checked={allSelected}
                onChange={toggleSelectAll}
                aria-label="Select all"
              />
            </div>
          )}
          <div className="table-cell capitalize">Vessel Name</div>
          <div className="table-cell">Fixed Sap Vessel Company Code</div>
          <div className="table-cell">Fixed Cost Center</div>
        </div>

        <div className="table-body custom-scroll">
          {isLoading || isFetching ? (
            <h1>Loading...</h1>
          ) : (
            <>
              {records && records.length > 0 ? (
                records.map((item) => {
                  const id = getRowId(item);
                  return (
                    <div key={id} className="table-row">
                      {canEdit && (
                        <div className="table-cell">
                          <input
                            type="checkbox"
                            className="cost-select"
                            checked={selectedIds.includes(id)}
                            onChange={() => toggleSelectRow(id)}
                            aria-label={`Select ${id}`}
                          />
                        </div>
                      )}
                      <div className="table-cell">
                        <div className="flex flex-col">
                          <span>{formatVesselDisplay(item)}</span>
                          {vesselStatus(item) && (
                            <span className="text-gray-200 text-xs italic font-normal">
                              {renderLabel(vesselStatus(item))}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="table-cell">
                        <label>
                          {item?.fixedSapVesselCompanyCode}
                        </label>
                      </div>
                      <div className="table-cell">
                        <label>{getCostCenterDisplay(item)}</label>
                      </div>
                    </div>
                  );
                })
              ) : (
                <h1>No Data Available</h1>
              )}
            </>
          )}
        </div>
      </div>

      {!isLoading && (
        <>
          {totalRowsCount > 5 && (
            <ApiPagination
              {...{
                setpageNumber,
                pageNumber,
                totalPages,
                paginationRowList,
                handleRowsCount,
                rowsCount
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default FixedBudgetVesselTable;
